import { styled } from '@linaria/react';
import Download from './svg/download.svg?react';

export const StyledDownload = styled(Download)`
  width: 20px;
`;
